export default {
    enableText: '启用',
    disableText: '禁用',
    enableTexts: 'user',
    disableTexts: 'admin',
    yesText: '是',
    noText: '否',
    ExitedText: '已离场',
    notUsedText: '未使用',
    usedText: '已使用',
    notHaveText: '无',
    haveText: '有',
    notInitializedText: '未初始',
    initializedText: '已初始',
    manText: '男',
    womanText: '女',
    ACTIVEText: '已激活',
    UNACTIVEText: '未激活',
    physicalGoodsText: '实物商品',
    virtualGoodsText: '虚拟商品',
    generalMerchandiseText: '普通商品',
    EditingText: '编辑中',
    editSuccessfulText: '编辑成功',
    editFailedText: '编辑失败',
    CancellingText: '取消中',
    cancelSuccessfulText: '取消成功',
    cancelFailedText: '取消失败',
    packageItemText: '组合商品',
    roughDraftText: '草稿',
    tobeReviewedText: '待审核',
    approvedText: '审核通过',
    rejectedText: '被驳回',
    underReviewText: '审核中',
    effectiveText: '已生效',
    effectiveEditingText: '已生效-编辑中',
    effectiveRejectedText: '已生效-被驳回',
    notSubmittedReviewText: '未提交审核',
    completedText: '已完成',
    completedOrderText: '已完成订单',
    cancelOrderText: '已取消订单',
    allOrderText: '全部订单',
    costPriceText: '成本价',
    salesPriceText: '销售价',
    activityPriceText: '活动价',
    marketPriceText: '市场价',
    distributionPriceText: '分销价',
    tradePriceText: '批发价',
    settlementPriceText: '结算价',
    haveInHandText: '进行中',
    failedText: '失 败',
    noConsumersText: '无消费者',
    waitingToBepulledText: '等待被拉取',
    creditone:"单独的信用票据，审批后发送",
    credittwo:"添加到发票，下周发送",
    AlibabaCloudText: '阿里',
    HuaweiCloudText: '华为',
    TencentCloudText: '腾讯',
    QiniuCloudText: '七牛',
    LocalText: '本地',
    JDCloudText: '京东云',
    BaiduCloudText: '百度云',
    automaticLogonText: '自动注册',
    manualEntryText: '手动录入',
    radioText: '单选框',
    checkBoxText: '复选框',
    textBoxText: '文本框',
    dropdownBoxText: '下拉框',
    loseEfficacyText: '失效',
    efficacyText: '有效',
    positiveSequenceText: '正序',
    invertedOrderText: '倒序',
    onlineStoreText: '网店',
    storeText: '门店',
    orderText: '序列',
    constantText: '常量',
    dateText: '日期',
    variableText: '变量',
    defaultVirtualWarehouseText: '默认虚仓',
    solidWarehouseText: '实仓',
    logicalWarehouseText: '逻辑仓',
    orderItemShortagePriorityText: '订单商品缺货优先',
    priorityGivenToStoreProductShortageText: '店铺商品缺货优先',
    notPublishedText: '未发布',
    publishedText: '已发布',
    notSetText: '未设置',
    setText: '已设置',
    auditSucceededText: '审核成功',
    auditFailedText: '审核失败',
    voidedText: '已作废',
    tombstoneText: '逻辑删除',
    deactivateText: '停用',
    onHoldText: '暂停',
    openText: '开启',
    suspendText: '暂停',
    PausedText: '已暂停',
    NotPausedText: '未暂停',
    deadlineText: '到时截止',
    toBeWrittenOffText: '待核销',
    auditRejectText: '审核拒绝',
    canceledText: '已取消',
    wornText: '破损',
    lostPartsText: '丢件',
    NormalStandardSellingPriceText: '普通标准售价',
    ExfactoryPriceText: '出厂价',
    InTransitText: '在途',
    CollectedText: '揽收',
    ExceptionText: '疑难',
    DeliveredText: '签收',
    SignBackText: '退签',
    OutForDeliveryText: '派件',
    TransferText: '转单',
    AwaitingClearanceText: '待清关',
    ClearanceInProgressText: '清关中',
    ClearedText: '已清关',
    ClearanceExceptionText: '清关异常',
    freightTemplateMismatchText: '运费模板不匹配',
    logisticsMismatchText: '物流不匹配',
    businessMismatchText: '业务不匹配',
    untreatedText: '未处理',
    processedText: '已处理',
    ContainerText: '集装箱',
    PalletsText: '托盘',
    CartonText: '纸箱',
    LooseText: '散装',
    PalletText: '托盘',
    billingByWeightText: '按重量计费',
    fixedPriceText: '固定价格',
    standardUserText: '标准客户',
    nonStandardUserText: '非标准客户',
    internalAllocationPriceText: '内部分摊价',
    NotWrittenBackText: '未回写',
    WriteBackSucceededText: '回写成功',
    WriteBackFailedText: '回写失败',
    UnreceivedGoodsText: '未收货',
    PartialReceiptText: '部分收货',
    ReceivedText: '已收货',
    ReceivedText1: '已收款',
    DeclinedText: '已拒绝',
    DeclinedText1: '审批未通过',
    OrderReplenishmentText: '订单补货',
    ShopReplenishmentText: '店铺补货',
    wholeText: '全部',
    HEADCOUNT1: '计划用人待申报',
    HEADCOUNT2: '计划用人审批中',
    HEADCOUNT3: '超用驳回',
    HEADCOUNT4: '实际用人待申报',
    HEADCOUNT5: '已完成',
    OVERTIME1: '加班计划审批中',
    OVERTIME2: '加班计划驳回',
    OVERTIME3: '加班计划已通过',
    cnPurchaseTypeText: '中国采购',
    auPurchaseTypeText: '澳洲采购',
    ukPurchaseTypeText: '英国采购',
    SystemText: '系统',
    ManualText: '手动',
    FrozenText: '已冻结',
    UnfrozenText: '未冻结',
    ApprovalText: '待审批',
    AwaitingProcessingText: '待处理',
    ProgressText: '处理中',
    processingText: '处理中',
    GeneralemailText: '通用邮箱',
    BillingEmailText: '账单邮箱',
    CustomerServiceEmailText: '客服邮箱',
    TemporaryStrong:"暂存",
    Discard:"丢弃",
    InProcessing:"运输中",
    Restocked:"重新上架",
    Waitingforreturntowarehouse:"待回仓",
    Completed:"完成",
    allText:"全部",
    WalletBalance:"钱包余额",
    WalletTransaction:"钱包流水",
    NotApprovedText: '审批不通过',
    CancelledText: '已作废',
    ordinaryText: '普通',
    urgentText: '紧急',
    auditPassText: '同意',
    auditNotPassText: '拒绝',
    DesignatedDepartmentText : '指定部门',
    BillingStatusPREVIEW: '待确认',
    ConfirmationPending: '待确认',
    CompletedText: '已处理',
    BillingStatusPAID: '已付款',
    BillingStatusPARTIAL: '部分付款',
    BillingStatusUNPAID: '未付款',
    BillingStatusOVERPAID: '超额付款',
    BillingStatusDRAFT: '草稿',
    BillingStatusRUNNING: '正式运行',
    BillingStatusSTOP: '已下线',
    BillingStatusRange: '区间',
    BillingStatusNormal: '默认',
    BillingStatusSection: '部分',
    newQuotationTypeText: '新品',
    oldQuotationTypeText: '旧品',
    returnOrderStatusPendingText: '待处理',
    returnOrderStatusBackText: '完成',
    returnOrderStatusAbandonedText: '废弃',
    returnProductStatusCompleteText: '完整的',
    returnProductStatusDamagedText: '有损坏',
    waitStockInText: '待入库',
    allStockInText: '全部入库',
    successPushSapText: 'SAP推送成功',
    failPushSapText: 'SAP推送失败',
    PendingFirstTrialText: '待一审',
    PendingSecondReviewText: '待二审',
    PassedInTheFirstInstanceText: '一审通过',
    RefusalOfFirstInstanceText: '一审拒绝',
    PassedInTheSecondInstanceText: '二审通过',
    RejectionOfSecondInstanceText: '二审拒绝',
    ToBeRefundedText: '待退款',
    RefusedText: '已拒绝',
    PurchaseWaitFirstAuditText: '待一审',
    PurchaseFirstAuditRejectedText: '一审拒绝',
    PurchaseWaitSecondAuditText: '待二审',
    PurchaseSecondAuditRejectedText: '二审拒绝',
    PurchaseWaitThirdAuditText: '待三审',
    PurchaseThirdAuditRejectedText: '三审拒绝',
    PurchaseCompletedText: '已完成',
    PurchaseCancelledText: '已废弃',
    PurchaseWaitCreateText: '待生产',
    PurchaseProducingText: '在产',
    PurchaseWaitPurchaseText: '待生成采购单',
    PurchaseDraftText: '草稿',
    AbnormalDocumentTransferText: '转单异常',
    ToBeReturnedByTheBuyerText: '待买家退货',
    ToBeAcceptedByTheWarehouseText: '待仓库验收',
    ToBeShippedFromWarehouseText: '待仓库发货',
    ToBeReceivedByTheBuyerText: '待买家收货',
    AuditTimeoutText: '审核超时',
    OutOfStockTimeoutText: '缺货超时',
    DeliveryTimeoutText: '发货超时',
    OrderUpdateTimeoutText: '订单更新超时',
    ToBeShippedText: '待发货',
    BuyerCancellationText: '买家取消',
    CloseExchangeText: '关闭换货',
    RefusalToExchangeGoodsText: '拒绝换货',
    OnlineStorePlatformRefundText: '网店平台退款',
    normalText: '正常',
    unusualText: '异常',
    RefundOnlyText: '仅退款',
    ReturnRefundText: '退货退款',
    NotReturnedText: '未回传',
    AfterSalesHasBeenReturnedText: '售后已回传',
    NotSynchronizedText: '未同步',
    SynchronizedText: '已同步',
    PendingText: '待处理',
    PurchasedText: '已采购',
    TransferredText: '已调拨',
    WarehouseMovedText: '已移仓',
    GeneralOrderText: '普通订单',
    O2OOrdersText: 'O2O订单',
    QUATEStatus0: '未报价',
    QUATEStatus1: '待确认',
    QUATEStatus2: '已确认',
    QUATEStatus3: '已拒绝',
    StoreSelfCollectionText: '门店自提',
    LogisticsDistributionText: '物流配送',
    OrdinaryDocumentTransferText: '普通转单',
    ManualOrderText: '手工单',
    CopyOrderText: '复制单',
    RepeatOrderText: '重发单',
    unfinishedText: '未完成',
    ClosedText: '已关闭',
    UNClosedText: '未关闭',
    ReceiptToBeConfirmed: '待确认收货',
    AllToBeReservedText: '全部待预占',
    AllPreOccupiedSuccessfullyText: '全部预占成功',
    FailedToPreOccupyAllText: '全部预占失败',
    PartialPreoccupationText: '部分预占',
    CancelPreemptionText: '取消预占',
    ToBeReservedText: '待预占',
    PreoccupiedSuccessfullyText: '预占成功',
    PreemptionFailedText: '预占失败',
    UnoccupiedSuccessfullyText: '解占成功',
    AllToBeWrittenBackText: '全部待回写',
    WriteBackAllSucceededText: '全部回写成功',
    FailedToWriteBackAllText: '全部回写失败',
    PartialWritebackText: '部分回写',
    ToBeWrittenBackText: '待回写',
    AllSourcesToBeSoughtText: '全部待寻源',
    AllSourcingSucceededText: '全部寻源成功',
    AllSourcingFailedText: '全部寻源失败',
    PartialSourcingText: '部分寻源',
    CancelSourcingText: '取消寻源',
    SourceToBeBoughtText: '待寻源',
    SourcingSucceededText: '寻源成功',
    SourcingFailedText: '寻源失败',
    initialText: '初始',
    AllToBeShippedText: '全部待发货',
    AllShipmentsSucceededText: '全部发货成功',
    FailedToShipAllText: '全部发货失败',
    PartialShipmentText: '部分发货',
    ShipmentSucceededText: '发货成功',
    ShipmentFailedText: '发货失败',
    GoodsToBeReceivedText: '待收货',
    AllReceivedText: '全部已收货',
    NotPendingText: '未挂起',
    STAGE_LIST1: '申请提交',
    STAGE_LIST2: '文件审批',
    STAGE_LIST3: '财务审批',
    STAGE_LIST4: 'ERP账号创建',
    STAGE_LIST5: '清单上传',
    STAGE_LIST6: 'ERP 培训',
    STAGE_LIST7: 'IT实施',
    STAGE_LIST8: '最终确认',
    STAGE_LIST9: '完成',
    OrderAllStatusNEWText: '新订单',
    OrderAllStatusProcessingText: '处理中订单',
    OrderAllStatusErrorText: '异常订单',
    OrderAllStatusOutofStockText: '缺货订单',
    BusinessAbnormalOrderWAIRING: '等待发货',
    OrderAllStatusCollectText: '等待取货',
    OrderAllStatusCollectLabelText: '已上传面单',
    AllSuspendedSuccessfullyText: '全部挂起成功',
    FailedToSuspendAllText: '全部挂起失败',
    PartialPendingText: '部分挂起',
    SystemSuspendedSuccessfullyText: '系统挂起成功',
    SystemSuspendFailedText: '系统挂起失败',
    SystemDecouplingSucceededText: '系统解挂成功',
    SystemDecouplingFailedText: '系统解挂失败',
    SuccessfullySuspendedManuallyText: '人工挂起成功',
    ManualSuspendFailedText: '人工挂起失败',
    ManualDecouplingSucceededText: '人工解挂成功',
    ManualDecouplingFailedText: '人工解挂失败',
    FailToPassTheFirstInstanceText: '一审不通过',
    FailTheSecondInstanceText: '二审不通过',
    AlipayText: '支付宝',
    QQPaymentText: 'QQ支付',
    WeChatpaymentText: '微信支付',
    TenpayText: '财付通',
    ContinuousPaymentText: '连连支付',
    OnlineBankingText: '网银在线',
    cashOnDeliveryText: '货到付款',
    BankRemittanceTransferText: '银行汇款/转账',
    otherText: '其他',
    UnpaidText: '未支付',
    PaidText: '已支付',
    GeneralChargebackText: '普通退单',
    RefundOnlyIfNotShippedText: '未发货仅退款',
    OnSaleText: '售中',
    AfterSalesText: '售后',
    ReturnWithoutReasonWithin7DaysText: '7天无理由退货',
    NotClosedText: '未成交',
    tradedText: '已成交',
    NoAfterSalesServiceText: '无售后',
    AfterSalesProcessingText: '售后处理中',
    RefundingText: '退款中',
    RefundSucceededText: '退款成功',
    InterfaceGrabText: '接口抓取',
    ManualDocumentCreationText: '手工建单',
    EXCELImportText: '导入',
    NoInvoicingRequiredText: '无需开票',
    SellerPackageText: '卖家包邮',
    ToBeNotifiedWMSText: '待通知WMS',
    ToBeDeliveredText: '待出库',
    FailedToNotifyWMSText: '通知WMS失败',
    AllOutboundText: '全部出库',
    PartialDeliveryText: '部分出库',
    CancelIssueText: '取消出库',
    ParsingSucceededText: '解析成功',
    NoParsingRequiredText: '无需解析',
    ReconciledText: '已对账',
    UnreconciledText: '未对账',
    NoReconciliationRequiredText: '无需对账',
    paymentForGoodsText: '货款',
    commissionText: '佣金',
    OrthocurrentWaterText: '正流水',
    NegativeCurrentText: '负流水',
    AmountAbnormalityText: '金额异常',
    SignedForText: '已签收',
    ReturnedText: '已退回',
    visaRejectedText: '拒签',
    SettledText: '已结算',
    UnsettledText: '未结算',
    roundDownText: '向下舍取整',
    roundUpText: '向上舍取整',
    transferVirtualWarehouseText: '中转虚仓',
    proportionalVirtualWarehouseText: '比例虚仓',
    quantityVirtualWarehouseText: '数量虚仓',
    salesRevenueText: '销售收入',
    refundExpensesText: '退款支出',
    DetailsOfAllExpensesText: '所有费用明细',
    MatchingFeeDetailsText: '匹配费用明细',
    UnMatchingFeeDetailsText: '未匹配费用明细',
    mateText: '匹配',
    MatchingAmountText: '匹配(金额差异)',
    mismatchingText: '不匹配',
    ConfirmedText: '已确认',
    UnconfirmedText: '未确认',
    Batchconfirmation: '批量确认',
    AmountDifferenceText: '金额差异',
    GetFixedFieldsText: '取固定字段',
    calculateAccordingToTheFormulaText: '按公式计算',
    SalesOrderText: '销售单',
    RefundOrderText: '仅退款单',
    ReturnAndRefundOrderText: '退货退款单',
    ExchangeOrderText: '换货单',
    handMovementText: '手动',
    voluntarilyText: '自动',
    MeetsAllOfTheFollowingConditionsText: '满足以下所有条件',
    MeetsAnyOfTheFollowingConditionsText: '满足以下任一条件',
    SalesChannelText: '销售渠道',
    OrderSourceText: '订单来源',
    OrderTypeText: '订单类型',
    OrderFlagText: '订单标记',
    ThirdPartyPlatformDownloadText: '三方平台下载',
    ManuallyCreatedText: '手工创建',
    FileImportText: '文件导入',
    stockoutText: '缺货',
    OrderCompletedText: '订单完成',
    ShipmentCompletedText: '发货完成',
    AfterSalesChannelText: '售后渠道',
    AfterSalesOrderSourceText: '售后单来源',
    AfterSalesOrderTypeText: '售后单类型',
    AfterSalesCompletedText: '售后完成',
    AuditCompletedText: '审核完成',
    NotStartedText: '未开始',
    InProgressText: '进行中',
    EndedText: '已结束',
    TerminatedText: '已中止',
    ThirdPartyOrderTimeText: '三方下单时间',
    PaymentTimeText: '支付时间',
    AllStoresText: '所有店铺',
    SpecifiedStoresText: '指定店铺',
    AllProductsInStoreText: '店铺内所有商品',
    SpecifiedProductsText: '指定商品',
    FullGiftText: '满件赠',
    ReissueOrderText: '补发单',
    ReturnOrderText: '退货单',
    RefundNoteText: '退款单',
    OrderOutOfStockText: '订单缺货',
    OrderExceptionText: '订单异常',
    MarketingProductsText: '营销商品',
    PurchaseOrdersText: '采购单',
    NormalCategoryText: '普通类目',
    LeafCategoryText: '叶子类目',
    All: '新增',
    SystemDefaultText: '系统默认',
    ParentCategoryText: '父级分类',
    AdditionalAttributeText: '附加属性',
    ProductAttributeText: '商品属性',
    CategoryAttributeText: '分类属性',
    NotDeployedText: '未布署',
    DeployedText: '已布署',
    MenuText: '菜单',
    ButtonText: '按钮',
    PageText: '页面',
    TabText: '标签',
    ReviewedText: '已审核',
    ByThirdPpartyOrderTimeText: '按三方下单时间',
    ByThirdPpartyOrderTimeText2: '按平台下单时间',
    ByInternalCreationTimeText: '按内部创建时间',
    ByChannelText: '按渠道',
    ByMonthText: '按月份',
    ByRegionText: '按地区',
    UnauthorizedText: '未授权',
    AuthorizedSuccessfullyText: '授权成功',
    AuthorizationInvalidText: '授权失效',
    AuthorizationSuspendedText: '授权停用',
    MatchedSuccessfullyText: '匹配成功',
    MatchedFailedText: '匹配失败',
    AutomaticMatchingText: '自动匹配',
    ManualMatchingText: '手动匹配',
    OnShelfText: '已上架',
    OffShelfText: '已下架',
    NormalProductText: '普通商品',
    PromotionalProductText: '活动商品',
    clientText: '客户端',
    NotPrintedText: '未打印',
    PrintedText: '已打印',
    SalesStoreText: '销售店铺',
    selectText: '选择',
    RoleText: '角色',
    AccountNumberText: '账号',
    PersonalCenterText: '个人中心',
    ExitSystemText: '退出系统',
    SelectProductText: '选择商品',
    SelectVirtualProductText: '选择虚拟商品',
    SelectPhysicalItemText: '选择实物商品',
    SelectPackageProductText: '选择组合商品',
    SelectCommonProductText: '选择普通商品',
    SelectSKUText: '选择SKU',
    SelectPOText: '选择入库单',
    SelectOrderText: '选择订单',
    SelectStoreText: '选择店铺',
    SelectOnlineStoreText: '选择网店',
    SelectWarehouseText: '选择仓库',
    SelectLogicalWarehouseText: '选择逻辑仓',
    SelectPhysicalWarehouseText: '选择实仓',
    SelectSalesOrderText: '选择关联销售单',
    SelectRefundProductText: '选择退款商品',
    SelectThirdPartyOrderText: '选择关联三方订单',
    SelectSupplierProductText: '选择供应商商品',
    SelectPurchaseOrderText: '选择采购单',
    OrderLogText: '订单日志',
    SupplierLogText: '供应商日志',
    staffSelectText: '选择仓库人员',
    welcomeText: '欢迎进入CSG ERP系统',
    lockTip1: '尊敬的客户，',
    lockTip2: '您好！我们希望您一切顺利。我们在此通知您，您的账户已因以下原因之一被暂时限制：',
    lockTip3: '1.未支付的逾期账单，或',
    lockTip4: '2.您的账户超出了分配的信用额度。',
    lockTip5: '为了恢复账户的完整访问权限，请尽快完成必要的付款。如果限制是由于信用额度问题，请及时联系我们的客服团队寻求帮助。',
    lockTip6: '感谢您对此事的及时关注。',
    formatErrorText: '格式错误',
    PleaseAddressText: '请输入地址',
    IncorrectAddressFormatText: '地址格式不正确',
    PleaseEmailAddressText: '请输入邮箱',
    MailboxFormatText: '邮箱格式错误',
    PleaseAccountText: '请输入账户',
    PleaseCorrectAccountText: '请输入正确的账户',
    PleasePhoneNumberText: '请输入手机号',
    MobileFormatErrorText: '手机号格式错误',
    PleaseClassificationText: '请输入分类名称',
    PleaseCENText: '中文，英文字母，数字',
    Please20NumbersText: '请输入不大于20位的数字及字母组合',
    ContentText: '内容',
    LastweekText: '最近一周',
    LastmonthText: '最近一个月',
    LastThreeMonthsText: '最近三个月',
    oneText: '一',
    twoText: '二',
    threeText: '三',

    OrganizationText: '关联组织架构',
    OperatingUserText: '操作用户',
    OperationContentText: '操作内容',
    OperatingTimeText: '操作时间',
    MsgErrorListText: '获取数据列表失败',
    ConfirmImportText: '确认导入',
    UploadFileSizeText: '上传文件大小最大不能超过128M',
    DownTemplate: '请添加模板地址',
    TemplatedMsgText: '缺少参数',
    UploadMsgText: '文件已提交，可前往 导入历史 页面查看导入结果',
    UploadMainText1: '将文件拖到此处，或',
    UploadMainText2: '点击上传',
    UploadMainHint1: '只能上传',
    UploadMainHint2: '文件，且不超过',
    UploadSuccessText: '成功数量',
    UploadFailText: '失败数量',
    UploadTotalText: '总数量',
    UploadFormatText1: '仅支持',
    UploadFormatText2: '格式，当前文件格式为',
    UploadMsgError: '大小不能超过',
    ReplicationSucceededText: '复制成功',
    copyText: '复制',
    createText: '创建',
    uploadedFormatText: '上传图片格式不正确，请重新上传',
    uploadedSizeText: '上传图片大小不能超过',
    loginSucceededText: '登录成功',
    FormatText1: '格式',
    FormatText2: '的格式为',

    appliesMerchantText: '买家申请退款，待商家处理',
    processedMerchantText: '退货退款，待商家处理',
    refundMerchantText: '商家同意退款，退款中',
    agreesMerchantText: '平台同意退款，退款中',
    rejectedMerchantText: '驳回退款，待买家处理',
    returnMerchantText: '已同意退货退款,待用户发货',
    PlatformMerchantText: '平台处理中',
    refusesMerchantText: '平台拒绝退款，退款关闭',
    revocationMerchantText: '买家撤销',
    notprocessedMerchantText: '买家逾期未处理，退款失败',
    overdueMerchantText: '买家逾期，超过有效期',
    processingMerchantText: '换货补寄待商家处理',
    pendingMerchantText: '换货补寄待用户处理',
    successfulMerchantText: '换货补寄成功',
    failedMerchantText: '换货补寄失败',
    confirmedMerchantText: '换货补寄待用户确认完成',
    WaitMerchantText: '待商家同意维修',
    shipmentMerchantText: '待用户确认发货',
    closedMerchantText: '维修关闭',
    RepairMerchantText: '维修成功',
    confirmationMerchantText: '待用户确认收货',
    rejectMerchantText: '已同意拒收退款，待用户拒收',
    SupplementaryMerchantText: '补寄待商家发货',
    rootText: '根目录',
    importHistoryText: '导入历史',
    reasonText: '原因',
    AllocationRatioText: '分配比例',
    straightLineText: '直线',
    polylineText: '折线',
    avoidanceLineText: '避让线',
    railLineText: '铁轨线',
    relationshipLineText: '关系线',
    itemText: '普通商品',
    packageText: '包装材料',
    matchingAnomalyText: '商品匹配异常',
    sizeAnomalyText: '商品尺寸异常',
    timeAnomalyText: '下单时间异常',
    addressAnomalyText: '收货地址异常',
    priceAnomalyText: '单价异常',
    phoneAnomalyText: '收件人手机号异常',
    SKUDimensionText: 'SKU尺寸异常',
    AddressExceptionText: '收件地址异常（超过40字符）',
    informationAnomalyText: '收件人信息异常',
    supplierAnomalyText: '平台/供应商异常',
    taxAnomalyText: '税号异常',
    AccountAnomalyText: '账户号异常',
    CurrencyAnomalyText: '货币异常',
    ItemAnomalyText: '项目异常',
    StoreAnomalyText: '店铺匹配异常',
    BuyerNotesText: '买家备注待客服审核',
    BuyerSTOCKText: '批次库存不足',
    BuyerSTOCKPOText: 'POBox超长超重',
    BuyerHSCodeText: '国际订单需提供HS Code 原产地 成本价',
    BuyerPickupText: 'Pickup 类型订单不允许填写收货地址',
    printText: '打印',

    loginTip: '请重新登录',
    Pendingurgentorders: '加急',
    PendingHJcancelorders: '待HJ取消',
    pohasnotclosed: '待ERP关闭的PO',
    dataDuplication: '数据重复',

    PackageDimensionsRequired: '包裹尺寸待提供',
    PackageDimensionsProvided: '包裹尺寸已提供',
    ShippingQuoteRequired: '物流报价待提供',
    FreightProvided: '物流报价已提供',
    FreightConfirmed: '物流报价已确认',
    ApprovedText2: '已审核',
    ApprovedPending: '审核中',
    ApprovedRejected: '审核拒绝',
    ApprovalDescription: '审核意见',
    RejectedTicket: '审批不通过工单',
    ApprovalPending: '待审批',
    OverdueTicket: '超时工单',
    ApprovalsOnboarding: '待审批入场客户',
    InStorage: '存储中',
    ShippingError: '邮寄方式没有配置，请检查',
    closingTime: '关闭时间',

    // 包裹类型
    Q_PackageText: '包裹',
    Q_DocumentText: '文件',
    Q_BagText: 'PAK袋',
    // 计算方式
    Q_LookupText: '速查',
    Q_IncrementalText: '增量',
};
